//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import BottomNav from "../components/BottomNav";
import EmptyCell from "../components/emptyCell";
import { getRoomsByMemberId } from "../../api/newOwner";

export default {
  name: "repair",
  components: {
    EmptyCell,
    BottomNav,
  },
  data() {
    return {
      leftIco: require("@/assets/img/ico-building.png"),
      list: [],
      isShowCert: false,
      show: false,
    };
  },
  methods: {
    projectBlock(e) {
      if (e.cityName == "长沙市" ||  e.cityName == "株洲市") {
        this.show = true;
        return;
      } else {
        this.$router.push({ path: "/repairForm/" + e.id + '/' + e.memberRoomType });

        // :to="{ path: '/repairForm/' + item.id }"
      }
    },
    getOwners() {
      let memberId = localStorage.getItem("MemberId");
      if (!memberId) {
        return;
      }

      getRoomsByMemberId(parseInt(memberId))
        .then((res) => {
          this.list = [];
          this.list.push(...res.data.result);
        })
        .finally(() => {});
    },
    certificate() {
      this.$router.push({ path: "/character" });
    },
    async getMyMember() {
      this.$toast.loading({
        duration: 0,
        message: "",
      });
      await this.$store
        .dispatch({
          type: "member/getMyMember",
        })
        .then(() => {
          this.member = this.$store.state.member.memberInfo;
          localStorage.setItem("MemberId", this.member.id);
          if (this.member.isAuthentication) {
            this.isShowCert = false;
            this.getOwners();
          } else {
            this.isShowCert = true;
          }
        })
        .finally(() => {
          this.$toast.clear();
        });
    },
  },
  created() {
    this.getMyMember();
  },
};
